module.exports = __webpack_public_path__ + "static/img/04.c023e3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/04.png
// module id = M9hH
// module chunks = 64